/* eslint-disable */
export default {
  monthly: 'Monthly',
  dailyStandard: 'DailyStandard',
  dailyAccelerated: 'DailyAccelerated',
  lifetimeBudgetStandard: 'LifetimeBudgetStandard'
};

